import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import styles from './SearchBrand.module.css'
import {
  useGetSparesByBrandCodeMutation,
} from '../../../../redux/searchSpares/apiSearchSpares'
import Loader from '../../../loader/Loader'
import SearchFinal from '../searchFinal/SearchFinal'
import { checkAllTablesAvailability } from '../../../../utils/checkSparesAvailability'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectSearchedSpare,
  setSearchedFinalSpare,
  setSearchedSpare,
} from '../../../../redux/searchSpares/sparesSlice'
import ModalSpareNotAvailable from '../../../modals/searchSpare/ModalSpareNotAvailable'
import filterString from '../../../../utils/filterString'

const SearchBrand = ({
  searchBrand,
  setSearchBrand,
  isQuickSearchUsed,
  setIsQuickSearchUsed,
}) => {
  const [searchFinal, setSearchFinal] = useState(null)
  const [searchedBrand, setSearchedBrand] = useState(null)
  const [isNoSparesAvailable, setIsNoSparesAvailable] = useState(false)

  const searchInput = useSelector(selectSearchedSpare)
  const dispatch = useDispatch()

  const [searchByBrandCode, { isLoading: isLoadingSearchByBrandCode }] =
    useGetSparesByBrandCodeMutation()

  const handleSearchFinal = async (analogueID, brand, code, spareID) => {
    setSearchedBrand(brand)
    try {
      dispatch(setSearchedFinalSpare({ brand, code, spareID, analogueID }))
      dispatch(setSearchedSpare(filterString(code)))
      const response = await searchByBrandCode({
        brand,
        spareCode: filterString(code),
        webQueryID: searchBrand?.webQueryID,
      })
      if (checkAllTablesAvailability(response.data, searchInput, brand)) {
        setSearchFinal(response.data)
      } else {
        setIsNoSparesAvailable(true)
      }
    } catch (error) {
      toast.error('Сталась помилка...')
    }
  }

  useEffect(() => {
    if (searchBrand?.selectedBrand) {
      const candidates = [
        ...(searchBrand?.mainSearch || []),
        ...(searchBrand?.asterixSearch || []),
      ]
      const matched = candidates.find(
        (item) =>
          filterString(item.brand) ===
          filterString(searchBrand.selectedBrand)
      )
      if (matched) {
        handleSearchFinal(
          matched.analogueID,
          matched.brand,
          filterString(matched.code),
          matched.spareID
        )
        return
      }
    }
    if (searchBrand?.mainSearch && searchBrand?.mainSearch.length === 1) {
      handleSearchFinal(
        searchBrand?.mainSearch[0].analogueID,
        searchBrand?.mainSearch[0].brand,
        filterString(searchBrand?.mainSearch[0].code),
        searchBrand?.mainSearch[0].spareID
      )
    } else if (
      isQuickSearchUsed &&
      searchBrand?.mainSearch &&
      searchBrand?.mainSearch.length > 1
    ) {
      const selectedGroup = searchBrand.selectedGroup?.toLowerCase()
      let targetBrands = []

      console.log(selectedGroup)
      if (selectedGroup?.includes('u-подібні хомути')) {
        targetBrands = searchBrand.mainSearch.filter((item) =>
          item.brand.toLowerCase().includes('u-хомут')
        )
      } else if (
        selectedGroup?.includes('хомути') &&
        !selectedGroup?.includes('u-подібні хомути')
      ) {
        targetBrands = searchBrand.mainSearch.filter(
          (item) =>
            item.brand.toLowerCase().includes('хомут') &&
            !item.brand.toLowerCase().includes('u-хомут')
        )
      } else if (selectedGroup?.includes('гальмівні трубки')) {
        targetBrands = searchBrand.mainSearch.filter((item) =>
          item.brand.toLowerCase().includes('трубк')
        )
      } else if (selectedGroup?.includes('паливні шланги')) {
        targetBrands = searchBrand.mainSearch.filter((item) =>
          item.brand.toLowerCase().includes('шланг')
        )
      } else {
        targetBrands = searchBrand.mainSearch.filter((item) =>
          item.brand.toLowerCase().includes('тип')
        )
      }

      if (targetBrands.length === 1) {
        handleSearchFinal(
          targetBrands[0].analogueID,
          targetBrands[0].brand,
          filterString(targetBrands[0].code),
          targetBrands[0].spareID
        )
      }

      setIsQuickSearchUsed(false)
    }
  }, [searchBrand, isQuickSearchUsed, searchInput, setIsQuickSearchUsed])

  useEffect(() => {
    if (
      searchBrand?.mainSearch &&
      searchBrand?.mainSearch.length === 0 &&
      searchBrand?.asterixSearch &&
      searchBrand?.asterixSearch.length === 0
    ) {
      setIsNoSparesAvailable(true)
      setSearchBrand(null)
      toast.error('За вашим запитом нічого не знайдено...')
    }
  }, [searchBrand, setSearchBrand])

  if (searchFinal) {
    return (
      <SearchFinal
        handleSearchFinal={handleSearchFinal}
        setSearchFinal={setSearchFinal}
        searchFinal={searchFinal}
        searchedBrand={searchedBrand}
      />
    )
  }

  if (isLoadingSearchByBrandCode) {
    return <Loader />
  }

  if (isNoSparesAvailable) {
    return (
      <ModalSpareNotAvailable setNoSparesAvailable={setIsNoSparesAvailable} />
    )
  }

  const filteredAsterixSearch =
    searchBrand?.asterixSearch?.filter(
      (asterixItem) =>
        !searchBrand.mainSearch?.some(
          (mainItem) =>
            mainItem.code === asterixItem.code &&
            mainItem.brand === asterixItem.brand
        )
    ) || []

  return (
    <>
      {searchBrand?.mainSearch?.length > 0 && (
        <table className={styles.searchTable}>
          <thead>
            <tr>
              <th className={styles.tableHeader}>Бренд</th>
              <th className={styles.tableHeader}>Номер</th>
              <th className={styles.tableHeader}>Опис</th>
            </tr>
          </thead>
          <tbody>
            {searchBrand.mainSearch.map((el, i) => (
              <tr
                onClick={() =>
                  handleSearchFinal(
                    el.analogueID,
                    el.brand,
                    el.code,
                    el.spareID
                  )
                }
                key={`main-${i}`}
              >
                <td className={styles.tableRowBrand}>{el.brand}</td>
                <td className={styles.tableRowBrand}>{el.code}</td>
                <td className={styles.tableRowBrand}>{el.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {filteredAsterixSearch?.length > 0 && (
        <>
          <h3>Можливо ви шукали:</h3>
          <table className={styles.searchTable}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Бренд</th>
                <th className={styles.tableHeader}>Номер</th>
                <th className={styles.tableHeader}>Опис</th>
              </tr>
            </thead>
            <tbody>
              {filteredAsterixSearch.map((el, i) => (
                <tr
                  onClick={() =>
                    handleSearchFinal(
                      el.analogueID,
                      el.brand,
                      el.code,
                      el.spareID
                    )
                  }
                  key={`asterix-${i}`}
                >
                  <td className={styles.tableRowBrand}>{el.brand}</td>
                  <td className={styles.tableRowBrand}>{el.code}</td>
                  <td className={styles.tableRowBrand}>{el.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  )
}

export default SearchBrand
